// @flow

import React, {type Node} from 'react';
import cs from 'classnames';

import * as urls from 'app/urls';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';

type Props = {
  icon?: string,
  onSidebar: boolean,
  onPopover?: boolean,
  head: Node | string,
  children?: Node | string | ((typeof FullHTMLLink, any) => Node | string),
  className?: string,
  classNameOverwrite?: string,
};

const NoResultsMessage = ({
  icon,
  head,
  onSidebar,
  onPopover,
  children,
  className,
  classNameOverwrite,
}: Props) => {
  const IconTag = onPopover ? 'h3' : 'h2';
  const HeadTag = onPopover ? 'h5' : onSidebar ? 'h4' : 'h3';
  const childreClass = onSidebar ? 'font-weight-light px-3' : 'lead';

  return (
    <div
      className={cs(
        classNameOverwrite != null
          ? classNameOverwrite
          : cs('my-5 text-center', className)
      )}
    >
      <IconTag className="text-muted">
        {icon != null ? <i className={`far fa-fw ${icon}`} /> : null}
      </IconTag>
      <HeadTag className={onSidebar ? 'px-3' : ''}>{head}</HeadTag>
      {children != null ? (
        <div className={`${childreClass} py-4 text-muted`}>
          {typeof children === 'function'
            ? children(FullHTMLLink, urls)
            : children}
        </div>
      ) : null}
    </div>
  );
};

NoResultsMessage.defaultProps = {
  onSidebar: false,
};

export default NoResultsMessage;
